import { createLocaleTextHook } from '@moonpig/web-core-locale-text'

export const useLocaleText = createLocaleTextHook({
  dictionary: {
    'more_like_this.title': {
      'en-GB': 'More like this',
      'nl-NL': 'Meer zoals dit',
    },
    'more_like_this.close_button_label': {
      'en-GB': 'Close more like this products',
      'nl-NL': 'Sluit meer zoals dit producten',
    },
  },
})
